export const MAX_PEER_REVIEW_LEVELS = 4;

export const DEFAULT_PEER_REVIEW_REMINDER_MINUTES = 60;

export const DEFAULT_PEER_REVIEW_TIMER_MINUTES = 240;

/** Matches backend PEER_REVIEW_MATRIX_DEFAULTS */
export const MIN_PEER_REVIEW_REMINDER_MINUTES = 1;
export const MAX_PEER_REVIEW_REMINDER_MINUTES = 1440;
export const MIN_PEER_REVIEW_TIMER_MINUTES = 1;
export const MAX_PEER_REVIEW_TIMER_MINUTES = 10080;
